export enum FilterTypeEnum {
  creditGrade = 'creditGrade',
  region = 'region',
  source = 'source',
  covenants_source = 'covenants_source',
  news_source = 'news_source',
  sector = 'sector',
  topic = 'topic',
  report = 'report',
  assetClass = 'assetClass',
}

export interface FilterItemDto {
  tagId: string;
  displayName: string;
  children?: FilterItemDto[];
}

export interface FilterDto {
  type: FilterTypeEnum;
  options: FilterItemDto[];
}

export interface Tag {
  name: string;
  tagId: string;
  ticker?: string;
}

export interface FilterTagItem {
  tagId: string;
  displayName: string;
  type: string;
}
